import { generateAutomationName } from "../../helpers/generateAutomationName";

export const activationSetDDKeys = {
    title: generateAutomationName("project", ["header", "activationDropdown", "title"]),
    icon: generateAutomationName("project", ["header", "activationDropdown", "icon"]),
};
